import { BaseIP } from "./CommonApi";

//http://192.168.195.102:8082/techno-muhurt/muhurt/transaction/getDailyReportData
export const getDailyReportDataAPIURL = BaseIP + "muhurt/transaction/getDailyReportData";

//Registered User Count
//192.168.29.102:8082/techno-muhurt/muhurt/userLogin/getRegisteredUserCount
export const getRegsiteredUserCountAPIURL = BaseIP + "muhurt/userLogin/getRegisteredUserCount";